// extracted by mini-css-extract-plugin
module.exports = {"linkPanel":"AlertPanelPart_linkPanel__dZL_d","informationIcon":"AlertPanelPart_informationIcon__PrzbP","noIngress":"AlertPanelPart_noIngress__F5w7C"};